module.exports = __webpack_public_path__ + "img/Icon__province_4.63cd9809.svg";